// @flow
import type { AxiosPromise, AxiosInstance } from "axios";

const registrationLookup = (
  registration: string
): ((apiInstance: AxiosInstance) => AxiosPromise<>) => (apiInstance) => {
  return apiInstance.get(`/v4/vehicles/registration-lookup`, {
    params: {
      registration
    }
  });
};

export default registrationLookup;
